export const GET_MY_AVATAR_DETAILS = 'GET_MY_AVATAR_DETAILS'
export const RESET_MY_AVATAR_DETAILS = 'RESET_MY_AVATAR_DETAILS'
export const MODIFY_MY_AVATAR_DETAILS = 'MODIFY_MY_AVATAR_DETAILS'
export const GET_AVATAR_COMPONENT_DETAILS = 'GET_AVATAR_COMPONENT_DETAILS'
export const GET_ALL_AVATAR_COMPONENT_DETAILS =
  'GET_ALL_AVATAR_COMPONENT_DETAILS'
